import classes from "./ReleaseActivityPage.module.css";
import React, {Fragment, useEffect, useRef, useState} from "react";
import {
    BUTTON,
    POLL_SHARE_MODE,
    POLL_STATE,
    POLL_TYPE,
    RELEASE_ACTIVITY_VIEW,
    SYNC_LMS_OPTIONS,
    WEBSOCKET_CHECK_HEARTBEAT_INTERVAL,
    WEBSOCKET_INSTRUCTOR,
    WEBSOCKET_MAX_TOLERANCE_HEARTBEAT_GAP,
    WEBSOCKET_MESSAGE_REMOVE_CONNECTIONS_ACTION
} from "../../utils/constants";
import {useParams} from "react-router-dom";
import { useTranslation } from "react-i18next";
import {ReactComponent as PENCIL_ICON} from "../../images/pencil_gray.svg";
import {ReactComponent as COPY_ICON} from "../../images/copy_gray.svg";
import {ReactComponent as PLUS_ICON} from "../../images/plus.svg";
import {ReactComponent as SQUARE_ICON} from "./images/square.svg";
import {ReactComponent as ARROW_LEFT} from "./images/arrow_left.svg";
import {ReactComponent as ARROW_RIGHT} from "./images/arrow_right.svg";
import {ReactComponent as METRICS_ICON} from "./images/metrics_icon.svg";
import {ReactComponent as TIME_LIMIT_ICON} from "../../images/time_limit_gray.svg";
import { ReactComponent as Megaphone } from "../../images/megaphone.svg";

import CopyToClipboard from "react-copy-to-clipboard";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";

import ViewQuestionCard from "./ViewQuestionCard";
import {useClassResultsAnalysisManager} from "../../hooks/useClassResultsAnalysisManager";
import {useJoinQuizWebsocketManager} from "../../hooks/useJoinQuizWebsocketManager";
import {ResponseApiCalls} from "../../apis/ResponseApiCalls";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import Countdown from "react-countdown";
import ViewReleaseOptions from "./ViewReleaseOptions";
import {PollApiCalls} from "../../apis/PollApiCalls";
import Lottie from "react-lottie";
import LiveClock from "./animations/live_clock.json";
import LiveClockRed from "./animations/live_clock_red.json";
import AddPollTimeModal from "../../components/modals/AddPollTimeModal";
import {
    convertTime,
    deCapitalizeWord,
    notifyError,
    notifySuccess,
    removePrefix
} from "../../utils/helpers";
import YuJaButton from "../../components/standardization/YuJaButton";
import { timeSecondsToCustomNew} from "../../utils/questionUtils";
import EndPollModal from "../../components/modals/EndPollModal";
import ViewMetricCards from "./ViewMetricCards";
import EditActivityModal from "../../components/modals/EditActivityModal";
import SAQuestion from "../../questions/SA/SAQuestion";
import {LatexHTMLInline} from "../../components/Tiptap/latexParser";
import ViewMetrics from "./ViewMetrics";
import ViewActivityInfoIcon from "./ViewActivityInfoIcon";
import ViewActivityShareButton from "./ViewActivityShareButton";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import {useConfig} from "../../hooks/useConfig";
import {Button} from "@base-ui/react/button";
import { Accordion } from '@base-ui/react/accordion';
import OverflowText from "../../components/OverflowText";

export default function ViewRelease({pollData, setPollData, pageView, setPageView, resetData, resetPollData, reloadPollData}) {
    const { t } = useTranslation();
    const { pollKey, pollCode } = useParams();
    let config = useConfig();
    const [, getSession] = useLocalStorageNew("session", {});
    const [, getTimeOffset] = useLocalStorageNew("timeOffset", 0);

    const [, getHostResource] = useLocalStorageNew(window.location.hostname, {});
    const { shareQuestion, shareAllQuestions, stopQuestion, stopAllQuestions, stopScheduledPoll, updatePollDetails, updateQuestionDetails, editPublishedPollDataFromKey } = PollApiCalls();
    const {getActiveStudentsInPoll, getResponsesDataByPoll} = ResponseApiCalls();
    const {getRedirectUrl, canHavePollCode} = useSynLMSConfiguration();
    const {poll={}, questions=[]} = pollData;

    const {pollTitle, gradeSchema, pollType, geofence, syncLms} = poll;

    const [copyCodeToolTip, setCopyCodeToolTip] = useState(
        pollType === POLL_TYPE.ATTENDANCE
            ? t("questionBuilder.copyAttendanceCodeDesc")
            : t("questionBuilder.copyPollCodeDesc")
    );
    const [openedQuestionNo, setOpenedQuestionNo] = useState(1);

    const [liveResponsesData, setLiveResponsesData] = useState([]);
    const [activeStudents, setActiveStudents] = useState({});


    const [queEnd, setQueEnd] = useState(Date.now());
    const [pollEnd, setPollEnd] = useState(Date.now());
    const [attendanceEndTime, setAttendanceEndTime] = useState("");

    const [localState, setLocalState] = useState("START POLL");
    const [sharedQuestionNo, setSharedQuestionNo] = useState(0);
    const [currentQuestionNo, setCurrentQuestionNo] = useState(1);
    const [questionIndexInputVal, setQuestionIndexInputVal] = useState(currentQuestionNo);
    const [mapInitialized, setMapInitialized] = useState(false);
    const [showAddTimeModal, setShowAddTimeModal] = useState(false);
    const [endPollModalShow, setEndPollModalShow] = useState(false);
    const [editActivityModalShow, setEditActivityModalShow] = useState(false);
    const [isShareQuestionProcessing, setIsShareQuestionProcessing] = useState(false);
    const [copied, setCopied] = useState(false);

    const countDownRef = useRef();
    const timeRemainingRef = useRef(0);
    const clipBoardRef = useRef();


    const shareAllAddTimeOptions = ["30 Secs", "1 Min", "5 Mins", "10 Mins", "20 Mins", "30 Mins"];
    const shareAllAddTimeToastDisplay = shareAllAddTimeOptions.map((time) => t("poll.addTimeAllSuccessMessage", {time: time.replace("Min", "minute").replace("Sec", "second")}));
    const shareAllAddTimeValues = [30, 60, 300, 600, 1200, 1800];
    const shareEachAddTimeOptions = ["15 Secs", "30 Secs", "1 Min", "5 Mins", "10 Mins", "20 Mins"];
    const shareEachAddTimeToastDisplay = shareEachAddTimeOptions.map((time) => t("poll.addTimeEachSuccessMessage", {time: time.replace("Min", "minute").replace("Sec", "second")}));
    const shareEachAddTimeValues = [15, 30, 60, 300, 600, 1200];
    const [isAddPollTimeModalLoading, setIsAddPollTimeModalLoading] = useState(false);

    const {
        responsesAnalysisData,
        participantsAnalysisData,
        participantsAllAnalysisData,
        browserAnalysisData,
        responseCountData,
        reactionCountData,
        participantsData,
    } = useClassResultsAnalysisManager(pollData, liveResponsesData);


    const LiveClockOptions = {
        loop: true,
        autoplay: true,
        animationData: LiveClock,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        }
    };

    const LiveClockRedOptions = {
        loop: true,
        autoplay: true,
        animationData: LiveClockRed,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        }
    };



    const btnStyle = {width: 130, height: 40, display: "flex", alignItems: "center", justifyContent: "center"};

    const stableScrollBarContainerStyle = {scrollbarGutter: "stable both-edges", overflowY: "hidden", paddingLeft: 2, paddingRight: 2, zIndex: 0};


    const isActivityEnded = () => {
        let isActivityEnd = false;

        if (poll.pollState === POLL_STATE.STOPPED_ALL || poll.pollState === POLL_STATE.STOPPED_SCHEDULED) {
            isActivityEnd = true;
        } else if (poll.pollType === POLL_TYPE.ATTENDANCE) {//attendance
            if (poll.pollState === POLL_STATE.STOPPED) {
                isActivityEnd = true;
            } else if (!!poll.endTime && Date.now() > new Date(poll.endTime).getTime()) {
                isActivityEnd = true;
            }
        } else if (
            poll.pollType !== POLL_TYPE.ATTENDANCE
            && poll.pollShareMode === POLL_SHARE_MODE.SHARE_EACH
            && !!poll.pollEnded
        ) {//share each
            isActivityEnd = true;
        } else if (poll.pollState === POLL_STATE.SCHEDULED && Date.now() > new Date(poll.endTime).getTime()) {//schedule
            isActivityEnd = true;
        } else if (poll.pollState === POLL_STATE.SHARED_ALL && !!poll.pollTimeLimit) {//automatic ended share all
            let pollEndPoint = poll.liveQuestionTime + parseInt(getTimeOffset()) + poll.pollTimeLimit * 1000;
            if (Date.now() > pollEndPoint) {
                isActivityEnd = true;
            }
        }

        return isActivityEnd;
    }

    const getWebSocketUrl = () => {
        let sessionUserName = getSession().userName ? getSession().userName : "";
        let sessionUserId = getSession().userId ? getSession().userId : "";
        let institutionId = getHostResource().institutionId;
        let url = `${config.wss_base_url}?pollKey=${pollKey}&pollCode=${pollCode}&userName=${sessionUserName}&userId=${sessionUserId}&role=${WEBSOCKET_INSTRUCTOR}&institutionId=${institutionId}`;
        return url;
    }


    const updateAllInfo = () => {
        getActiveStudentsInPoll(pollKey, pollCode).then(resp => {
            const {students=[]} = resp;
            const lastHeartbeat = Date.now();
            resp.students = students.map(i => {
                i.lastHeartbeat = lastHeartbeat;
                return i;
            });
            setActiveStudents(resp);
        });

        getResponsesDataByPoll(pollKey, pollCode).then(res => {
            setLiveResponsesData(res);
        });
    };



    const {isOpen, websocketMsg, buildConnection, closeConnection, sendMsg} = useJoinQuizWebsocketManager(getWebSocketUrl, updateAllInfo);

    useEffect(() => {
        buildConnection();

        return () => {
            closeConnection();
        }
    }, []);

    //check inactive websocket connections
    useEffect(() => {
        const interval = setInterval( () => {
            const activeStudentsCopy = JSON.parse(JSON.stringify(activeStudents));
            const {students: studentsCopy=[]} = activeStudentsCopy;
            const now = Date.now();
            const removedConnIds = [];
            const newStudents = [];
            for (let stu of studentsCopy) {
                const {lastHeartbeat=0, sk=""} = stu;
                if (!!lastHeartbeat && now - lastHeartbeat > WEBSOCKET_MAX_TOLERANCE_HEARTBEAT_GAP) {
                    removedConnIds.push(removePrefix(sk));
                    continue;
                }

                if (!lastHeartbeat) {
                    stu.lastHeartbeat = now;
                }
                newStudents.push(stu);
            }

            if (removedConnIds.length > 0) {
                activeStudentsCopy.students = newStudents;
                setActiveStudents(activeStudentsCopy);
                sendMsg({action: WEBSOCKET_MESSAGE_REMOVE_CONNECTIONS_ACTION, connectionIds: removedConnIds});
            }

        }, WEBSOCKET_CHECK_HEARTBEAT_INTERVAL);

        return () => clearInterval(interval);
    }, [activeStudents]);


    //back up policy
    useEffect(() => {
        let intervalId = 0;

        if (!isOpen) {
            updateAllInfo();
            intervalId = setInterval(() => {
                updateAllInfo();
            }, 15000);
        }

        return () => {
            if (!!intervalId) {
                clearInterval(intervalId);
            }
        }

    }, [isOpen]);

    useEffect(() => {
        if(!!websocketMsg.eventMessage && websocketMsg.eventMessage === "connect") {
            const now = Date.now();
            let {student={}, userResponse={}} = websocketMsg;
            const copy = JSON.parse(JSON.stringify(activeStudents));
            const {students=[]} = copy;
            const existedStudent = students.find(i => i.sk === student.sk);
            if (!!existedStudent) {
                existedStudent.lastHeartbeat = now;
            } else {
                student.lastHeartbeat = now;
                students.push(student);
            }

            setActiveStudents(copy);

            let copyData = JSON.parse(JSON.stringify(liveResponsesData));
            if (Object.entries(userResponse).length > 0) {
                copyData = copyData.filter(r => r.pollKey === userResponse.pollKey && r.pollSortKey !== userResponse.pollSortKey);
                copyData.push(userResponse);
                setLiveResponsesData(copyData);
            }
        }
        else if(!!websocketMsg.eventMessage && websocketMsg.eventMessage === "disconnect") {
            let {student={}} = websocketMsg;
            const copy = JSON.parse(JSON.stringify(activeStudents));
            let {students=[]} = copy;
            students = students.filter(i => i.sk !== student.sk);
            copy.students = students;
            setActiveStudents(copy);
        }
        else if(!!websocketMsg.eventMessage && websocketMsg.eventMessage === "updateResponse") {
            let {questionResponses=[], userResponse} = websocketMsg;
            if (questionResponses.length === 0) {
                return;
            }

            let responses = [...questionResponses];
            if (!!userResponse) {
                responses.push(userResponse);
            }

            const keySet = new Set(
                responses.map(response => {
                    const {pollKey="", pollSortKey=""} = response;
                    return `${pollKey}-${pollSortKey}`;
                })
            );

            let copyData = JSON.parse(JSON.stringify(liveResponsesData));
            copyData = copyData.filter(
                ({ pollKey="", pollSortKey="" }) => !keySet.has(`${pollKey}-${pollSortKey}`)
            );

            for (const response of responses) {
                copyData.push(response);
            }
            setLiveResponsesData(copyData);
        }
        else if (!!websocketMsg.eventMessage && websocketMsg.eventMessage === "updateReaction") {
            let {userResponse={}} = websocketMsg;
            let copyData = JSON.parse(JSON.stringify(liveResponsesData));
            copyData = copyData.filter(r => r.pollKey === userResponse.pollKey && r.pollSortKey !== userResponse.pollSortKey);
            copyData.push(userResponse);
            setLiveResponsesData(copyData);
        }
        else if (!!websocketMsg.eventMessage && websocketMsg.eventMessage === "heartbeat") {
            const now = Date.now();
            let {student={}} = websocketMsg;
            if (!student) {
                return;
            }
            const copy = JSON.parse(JSON.stringify(activeStudents));
            const {students=[]} = copy;
            const existedStudent = students.find(i => i.sk === student.sk);
            if (!!existedStudent) {
                existedStudent.lastHeartbeat = now;
            } else {
                student.lastHeartbeat = now;
                students.push(student);
            }

            setActiveStudents(copy);
        }
        else if (!!websocketMsg.eventMessage && websocketMsg.eventMessage === "reattemptPoll") {
            let {userResponse={}, questionResponses=[]} = websocketMsg;
            if (Object.entries(userResponse).length === 0) {
                return;
            }

            let responses = [...questionResponses];
            responses.push(userResponse);


            const keySet = new Set(
                responses.map(response => {
                    const {pollKey="", pollSortKey=""} = response;
                    return `${pollKey}-${pollSortKey}`;
                })
            );

            let copyData = JSON.parse(JSON.stringify(liveResponsesData));
            copyData = copyData.filter(
                ({ pollKey="", pollSortKey="" }) => !keySet.has(`${pollKey}-${pollSortKey}`)
            );

            for (const response of responses) {
                copyData.push(response);
            }
            setLiveResponsesData(copyData);
        }
    }, [websocketMsg]);


    useEffect(() => {
        const {liveQuestionNo = 0, pollState = '', pollShareMode, liveQuestionTime = 0, pollTimeLimit, index5Pk} = poll;


        if (pollState === POLL_STATE.STOPPED || pollState === POLL_STATE.STOPPED_ALL) {
            setLocalState("START POLL");
            if (pollState === POLL_STATE.STOPPED && poll.pollType !== POLL_TYPE.ATTENDANCE && resetData === 1) {
                // set current question no is the next unshared question
                let unsharedQuestions = questions.filter(q => !q.shareCount);
                if (unsharedQuestions.length > 0) {
                    setSharedQuestionNo(unsharedQuestions[0].serialNo);
                    setCurrentQuestionNo(unsharedQuestions[0].serialNo);
                }

            }
        } else if (pollState === POLL_STATE.SHARED_ALL) {
            let pollEndPoint= liveQuestionTime + pollTimeLimit * 1000;
            const currentTime = Date.now();

            if (liveQuestionTime > currentTime) {
                setPollEnd(pollEndPoint);
                setLocalState("GET_READY_ALL");
                // countDownRef.current?.start();
                return;
            }

            //unlimited share all
            if(!pollTimeLimit) {
                setPollEnd(pollEndPoint);
                setLocalState("SHARED_ALL");
                return;
            }

            if (pollEndPoint > currentTime) {
                setPollEnd(pollEndPoint);
                setLocalState("SHARED_ALL");
                // countDownRef.current?.start();
                return;
            }
        } else if (pollShareMode === POLL_SHARE_MODE.SCHEDULE) {
            const currentTime = new Date();

            if (poll.pollState === POLL_STATE.STOPPED_SCHEDULED
                || (poll.startTime && poll.endTime && (new Date(poll.endTime) < currentTime))
            ) {
                setLocalState("TIMEUP_ALL");
                return;
            }

            if (poll.startTime && poll.endTime && (new Date(poll.endTime) > currentTime && currentTime > new Date(poll.startTime) )) {
                setPollEnd(new Date(poll.endTime).getTime());
                setLocalState("SHARED_ALL");
                // countDownRef.current?.start();
                return;
            }

            if (poll.startTime && poll.endTime && new Date(poll.endTime) > currentTime) {
                setPollEnd(new Date(poll.endTime).getTime());
            }
        } else {
            if (liveQuestionNo < 1) {
                // handleFetchAllRespones(shareType, questions);
                return;
            }

            // if ((liveQuestionTime + (questions[liveQuestionNo-1].timeLimit * 1000)) < Date.now() && poll.pollType.toUpperCase() !== POLL_TYPE.SURVEY) {
            //     return;
            // }
            const liveQue = questions[liveQuestionNo - 1];

            const { timeLimit = 0 } = liveQue;
            let queEndPoint = pollType === POLL_TYPE.ATTENDANCE ? new Date(poll.endTime).getTime() : liveQuestionTime + timeLimit * 1000;
            const currentTime = Date.now();


            if (liveQuestionTime > currentTime) {
                setSharedQuestionNo(liveQuestionNo);
                if (resetData === 1) {
                    setCurrentQuestionNo(liveQuestionNo);
                }
                setQueEnd(queEndPoint);
                setLocalState("GET_READY");
                // countDownRef.current?.start();
                return;
            }


            if (queEndPoint > currentTime || !timeLimit) {
                setSharedQuestionNo(liveQuestionNo);
                if (resetData === 1) {
                    setCurrentQuestionNo(liveQuestionNo);
                }
                setQueEnd(queEndPoint);
                setLocalState("SHARED");
                // countDownRef.current?.start();
                return;
            }



            // untimed attendance
            if (poll.pollType === POLL_TYPE.ATTENDANCE
                && !poll.endTime // untimed attendance
                // && poll.hasOwnProperty("manualEnd") // ensure old attendances without manualEnd are not affected
            ) {
                setSharedQuestionNo(liveQuestionNo);
                if (resetData === 1) {
                    setCurrentQuestionNo(liveQuestionNo);
                }
                setQueEnd(Date.now());
                setLocalState("SHARED");
                return;
                // countDownRef.current?.start();
            }


            // set current question no is the next unshared question
            if (poll.pollType !== POLL_TYPE.ATTENDANCE && resetData === 1) {
                let unsharedQuestions = questions.filter(q => !q.shareCount);
                if (unsharedQuestions.length > 0) {
                    setSharedQuestionNo(unsharedQuestions[0].serialNo);
                    setCurrentQuestionNo(unsharedQuestions[0].serialNo);
                }
            }
        }

    }, [pollData]);

    useEffect(() => {
        setQuestionIndexInputVal(currentQuestionNo);
    }, [currentQuestionNo]);

    useEffect(() => {
        if (pageView !== RELEASE_ACTIVITY_VIEW.RELEASE_VIEW) {
            setMapInitialized(false);
        }

    }, [pageView]);


    const handleShare = async () => {
        try {
            setIsShareQuestionProcessing(true);
            await shareQuestion(pollKey, pollCode, currentQuestionNo, pollType);
            // createGradeColumn(pollKey, pollCode);
            resetPollData(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW);
        } finally {
            setIsShareQuestionProcessing(false);
        }

        // let quesTimeLimit = pollData.questions[currentQuestionNo-1].timeLimit;
        // setQueEnd(res.liveQuestionTime + parseInt(getTimeOffset()) + quesTimeLimit * 1000);
        // setSharedQuestionNo(currentQuestionNo);
        // setLocalState('GET_READY');
        // countDownRef.current.start();
    };


    const handleShareAll = async (pTimeLimit=undefined, getReadyAllTimeLimit=undefined) => {

        let requireUpdatePoll = pollData?.poll?.pollShareMode === POLL_SHARE_MODE.UNKNOWN
            || (pTimeLimit !== undefined && pTimeLimit !== pollData?.poll?.pollTimeLimit)
            || (getReadyAllTimeLimit !== undefined && getReadyAllTimeLimit !== pollData?.poll?.getReadyAllTimeLimit);

        if (requireUpdatePoll) {
            const pollDetails = {};
            pollDetails.pollShareMode = POLL_SHARE_MODE.SHARE_ALL;
            pollDetails.pollTimeLimit = pTimeLimit;
            pollDetails.manualEnd = !pTimeLimit;
            if (getReadyAllTimeLimit !== undefined) {
                pollDetails.getReadyAllTimeLimit =  getReadyAllTimeLimit;
            }

            await updatePollDetails(pollKey, pollCode, pollDetails, true);
        }
        let res = await shareAllQuestions(pollKey, pollCode);
        // createGradeColumn(pollKey, pollCode);
        resetPollData(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW);
        // if (requireUpdatePoll) {
        //     resetPollData();
        // } else {
        //     setPollEnd(res.liveQuestionTime + (parseInt(getTimeOffset()) + pTimeLimit ? pTimeLimit : pollData.poll.pollTimeLimit) * 1000);
        //     setLocalState('GET_READY_ALL');
        //     resetPollData();
        // }
    };

    const handleOpen = async (timeLimit=0) => {
        let manualEnd = !timeLimit; // no get ready time limit for attendance

        const pollDetails = {};
        pollDetails.pollShareMode = POLL_SHARE_MODE.SHARE_EACH;
        pollDetails.endTime = !!timeLimit ? new Date(Date.now() + timeLimit * 1000) : "";
        pollDetails.manualEnd = manualEnd;
        pollDetails.attendanceDuration = timeLimit;
        await updatePollDetails(pollKey, pollCode, pollDetails, true);
        await updateQuestionDetails(pollKey, pollCode, currentQuestionNo, {timeLimit: timeLimit});


        setAttendanceEndTime(!!timeLimit ? new Date(Date.now() + timeLimit * 1000) : null);
        await shareQuestion(pollKey, pollCode, 1, POLL_TYPE.ATTENDANCE);
        // createGradeColumn(pollKey, pollCode);
        setSharedQuestionNo(1);
        setLocalState('SHARED');
        resetPollData(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW);

    };

    const handleStop = async (isEndPoll=false) => {
        await stopQuestion(pollKey, pollCode, sharedQuestionNo, pollType, isEndPoll);
        resetPollData((isEndPoll || poll.pollType === POLL_TYPE.ATTENDANCE) ? RELEASE_ACTIVITY_VIEW.METRIC_VIEW : null);
    };

    const handleStopAll = async () => {
        if (poll.pollShareMode === POLL_SHARE_MODE.SCHEDULE) {
            await stopScheduledPoll(pollKey, pollCode);
            const copy = JSON.parse(JSON.stringify(pollData));
            copy.poll.pollState = POLL_STATE.STOPPED_SCHEDULED;
            setPollData(copy);
        } else {
            await stopAllQuestions(pollKey, pollCode);
        }

        resetPollData(RELEASE_ACTIVITY_VIEW.METRIC_VIEW);

    };

    const checkShowAttendanceTimer = () => {
        let endTimeDate = new Date(poll.endTime).getTime();
        let currentDate = new Date().getTime();
        if (poll.endTime && endTimeDate > currentDate) {
            return true;
        } else if(endTimeDate <= currentDate) {
            return false;
        } else {
            return false;
        }
    };


    const isShareAll = () => {
        return poll.pollType !== POLL_TYPE.ATTENDANCE
            && (poll.pollShareMode === POLL_SHARE_MODE.SHARE_ALL || poll.pollShareMode === POLL_SHARE_MODE.SCHEDULE);
    }



    const renderTimer = ({ days, hours, minutes, seconds }) => {
        const question = pollType === POLL_TYPE.ATTENDANCE ? questions[0] : questions[(localState === 'SHARED' ? sharedQuestionNo : currentQuestionNo) - 1];

        if ((localState !== 'GET_READY_ALL' && pollType === POLL_TYPE.MERGED_POLL && isShareAll() && !pollData.poll.pollTimeLimit) //unlimited share all
            ||(localState !== 'GET_READY' && pollType === POLL_TYPE.MERGED_POLL && !isShareAll() && !question?.timeLimit) //unlimited share each
            || (pollType === POLL_TYPE.ATTENDANCE && !poll.endTime) //unlimited attendance
        ) {
            return <></>;
        }

        if (poll.pollShareMode === POLL_SHARE_MODE.SCHEDULE) {
            const currentTime = new Date();

            if (poll.pollState === POLL_STATE.STOPPED_SCHEDULED || (poll.startTime && poll.endTime && (new Date(poll.endTime) < currentTime))) {
                if (localState !== "TIMEUP_ALL") {
                    setLocalState("TIME_UP_ALL");
                }
            } else if (poll.startTime && poll.endTime && (new Date(poll.endTime) > currentTime && currentTime > new Date(poll.startTime) )) {
                if (localState !== "SHARED_ALL") {
                    setPollEnd(new Date(poll.endTime).getTime());
                    setLocalState("SHARED_ALL");
                }
            }

            return <></>;
        }



        if (localState === 'TIMEUP_ALL') {
            return (
                <>
                    <span className={classes.rowSeparator}/>
                    <span className={classes.countDownContainer}>
                        <TIME_LIMIT_ICON/> 00:00:00
                    </span>
                </>
            );
        }

        if (localState === 'TIMEUP') {
            return (
                <>
                    <span className={classes.rowSeparator}/>
                    <span className={classes.countDownContainer}>
                        <TIME_LIMIT_ICON/> 00:00:00
                    </span>
                </>
            );
        }

        const hoursView = ('00' + ((days * 24) + hours)).slice(-2);
        const minutesView = ('00' + minutes).slice(-2);
        const secondsView = ('00' + seconds).slice(-2);
        const urgent = days === 0 && hours === 0 && minutes === 0 && seconds < 6 && seconds !== 0;

        const time = (seconds + minutes * 60 + hours * 3600 + days * 86400);
        timeRemainingRef.current = time;


        if (localState === "START POLL"
            && (pollType === POLL_TYPE.ATTENDANCE
                || poll.pollShareMode === POLL_SHARE_MODE.SHARE_ALL)
        ) {
            return <></>;
        }

        if (localState === "START POLL" && !!question.timeLimit) {
            return (

                <>
                    <span className={classes.rowSeparator}/>
                    <span className={classes.countDownContainer}>
                        <TIME_LIMIT_ICON/>
                        {timeSecondsToCustomNew(question.timeLimit)}
                    </span>

                    {pollType !== POLL_TYPE.ATTENDANCE &&
                        <span
                            tabIndex={0}
                            className={classes.addTimeBtn}
                            onClick={() => setShowAddTimeModal(true)}
                        >
                            <PLUS_ICON/>
                            {t("poll.addTimeText")}
                        </span>
                    }
                </>
            );
        }

        if (localState === "GET_READY_ALL" && time > poll.pollTimeLimit) {
            return (
                <>
                    <span className={classes.rowSeparator}/>
                    <span className={classes.countDownContainer}>
                        {t("poll.getReadyLabel")} {time - poll.pollTimeLimit - 1}
                    </span>
                </>
            );
        }

        if (attendanceEndTime && (localState !== "GET_READY_ALL" && localState !== "GET_READY") && time > 86400) {
            if (document.getElementById("shareCountDown") !== null) {
                document.getElementById("shareCountDown").style.display = "none";
            }
        } else {
            if (document.getElementById("shareCountDown") !== null) {
                document.getElementById("shareCountDown").style.display = undefined;
            }
        }

        if (localState === "GET_READY" && time >  question.timeLimit) {
            return (
                <>
                    <div className={classes.rowSeparator}/>
                    <span className={classes.countDownContainer}>
                        {t("poll.getReadyLabel")} {time - question.timeLimit - 1}
                    </span>
                </>

            );
        }

        // pad with 2 leading zeros
        if (time && isShareAll() && time <= poll.pollTimeLimit) {
            setLocalState('SHARED_ALL');
            return (
                <>
                    <span className={classes.rowSeparator}/>
                    <span className={classes.countDownContainer} id="shareCountDown">
                        <Lottie
                            options={!!urgent ? LiveClockRedOptions : LiveClockOptions}
                            height={28}
                            width={28}
                            isClickToPauseDisabled={true}
                            style={{margin: 0}}
                        />
                        {hoursView}:{minutesView}:{secondsView}
                    </span>

                    <span
                        tabIndex={0}
                        className={classes.addTimeBtn}
                        onClick={() => setShowAddTimeModal(true)}
                    >
                        <PLUS_ICON/>
                        {t("poll.addTimeText")}
                    </span>
                </>
            );
        }

        if (time && !isShareAll() && time <= question.timeLimit) {
            setLocalState('SHARED');
            return (
                <>

                    <span className={classes.rowSeparator}/>
                    <span className={classes.countDownContainer} id="shareCountDown">
                     <Lottie
                         options={!!urgent ? LiveClockRedOptions : LiveClockOptions}
                         height={28}
                         width={28}
                         isClickToPauseDisabled={true}
                         style={{margin: 0}}
                     />
                            {hoursView}:{minutesView}:{secondsView}
                    </span>

                    {pollType !== POLL_TYPE.ATTENDANCE &&
                        <span
                            tabIndex={0}
                            className={classes.addTimeBtn}
                            onClick={() => setShowAddTimeModal(true)}
                        >
                            <PLUS_ICON/>
                            {t("poll.addTimeText")}
                        </span>
                    }
                </>
            );
        }

        return <></>;
    };


    const timeUp = () => {
        if ((pollType === POLL_TYPE.MERGED_POLL && isShareAll() && !pollData.poll.pollTimeLimit) // unlimited share all
            || (pollType === POLL_TYPE.MERGED_POLL && !isShareAll() && sharedQuestionNo > 0 && !pollData.questions[sharedQuestionNo - 1].timeLimit) // untimed share each
            || (pollType === POLL_TYPE.ATTENDANCE && !pollData.poll.endTime) // unlimited attendance
        ) {
            if (poll.pollState !== POLL_STATE.STOPPED && poll.pollState !== POLL_STATE.STOPPED_ALL) {
                setLocalState(isShareAll() ? "SHARED_ALL" : "SHARED");
            }
            return;
        }

        if(poll.pollType === POLL_TYPE.ATTENDANCE) {
            setLocalState("TIMEUP");
            setPageView(RELEASE_ACTIVITY_VIEW.METRIC_VIEW);
        } else if (isShareAll()) {
            setLocalState("TIMEUP_ALL");
            setPageView(RELEASE_ACTIVITY_VIEW.METRIC_VIEW);
        } else {
            setLocalState("TIMEUP");
        }
        if (poll.pollShareMode !== POLL_SHARE_MODE.SCHEDULE) {
            setTimeout(() => {
                setLocalState("START POLL");
            }, 2000);
        }
    };




    const renderActionButton = () => {
        let isSharingAll = (
            poll.pollShareMode === POLL_SHARE_MODE.SCHEDULE
                || poll.pollShareMode === POLL_SHARE_MODE.SHARE_ALL
            )
            && (localState === "GET_READY_ALL" || localState === "SHARED_ALL");

        let isSharing = localState === "GET_READY" || localState === "SHARED";

        let isUntimed = (pollType === POLL_TYPE.MERGED_POLL && isShareAll() && !pollData.poll.pollTimeLimit) // unlimited share all
            || (pollType === POLL_TYPE.ATTENDANCE && !pollData.poll.endTime); // if attendance then no need to time up


        return (
            <>
                {(poll.pollType === POLL_TYPE.ATTENDANCE || isShareAll()) &&
                    <Countdown
                        ref={countDownRef}
                        className="pollPanelTimerText"
                        autoStart={
                        ["SHARED_ALL", "SHARED", "GET_READY_ALL", "GET_READY"].includes(localState)
                            || (poll.pollShareMode === POLL_SHARE_MODE.SCHEDULE && !!pollEnd && pollEnd > Date.now())
                    }
                        date={isShareAll() ? pollEnd : queEnd}
                        key={isShareAll() ? pollEnd : queEnd}
                        renderer={renderTimer}
                        onComplete={timeUp}
                    />

                }

                {(
                    (poll.pollShareMode === POLL_SHARE_MODE.SHARE_ALL
                        && !isSharingAll
                        && !!poll.pollState
                        && !!questions.filter(q => !!q.shareCount).length
                    ) // ended share all or
                    || (poll.pollShareMode === POLL_SHARE_MODE.SCHEDULE && (Date.now() > new Date(poll.endTime).getTime() || poll.pollState === POLL_STATE.STOPPED_SCHEDULED)) //schedule
                    || ( poll.pollType === POLL_TYPE.ATTENDANCE && !isSharing && !!poll.pollState && !!questions.filter(q => !!q.shareCount).length) //ended attendance
                    || (
                        poll.pollType !== POLL_TYPE.ATTENDANCE
                        && poll.pollShareMode === POLL_SHARE_MODE.SHARE_EACH
                        && !!poll.pollEnded
                        ) //ended share each
                   ) &&

                    <>
                        <div className={classes.rowSeparator}/>
                        <Button
                            className={classes.smallBtn}
                            style={{width: 133}}
                            onClick={() => setPageView(RELEASE_ACTIVITY_VIEW.METRIC_VIEW)}
                        >
                            <METRICS_ICON style={{marginRight: 7}}/>
                            {t("poll.viewMetrics")}
                        </Button>
                    </>


                }


                {/*unknown*/}
                {poll.pollShareMode === POLL_SHARE_MODE.UNKNOWN &&

                    <>
                        <div className={classes.rowSeparator}/>
                        <div
                            tabIndex={0}
                            className={classes.releaseBtn}
                            onClick={() => setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_OPTION_VIEW)}
                        >
                            {pollType === POLL_TYPE.ATTENDANCE ? t("questionBuilder.releaseAttendanceButton") : t("questionBuilder.releasePollButton")}
                        </div>
                    </>
                }


                {/*share all and already stopped*/}
                {poll.pollShareMode === POLL_SHARE_MODE.SHARE_ALL && !isSharingAll &&
                    <>
                        <div className={classes.rowSeparator}/>
                        <div
                            tabIndex={0}
                            className={classes.releaseBtn}
                            onClick={() => setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_OPTION_VIEW)}
                        >
                            {!!questions.filter(q => !!q.shareCount).length ? t("questionBuilder.releaseAgainButton") : t("questionBuilder.releasePollButton")}
                        </div>
                    </>
                }


                {/*attendance and already stopped*/}
                {poll.pollType === POLL_TYPE.ATTENDANCE && poll.pollShareMode === POLL_SHARE_MODE.SHARE_EACH && !isSharing &&
                    <>
                        <div className={classes.rowSeparator}/>
                        <div
                        tabIndex={0}
                            className={classes.releaseBtn}
                            onClick={() => setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_OPTION_VIEW)}
                        >
                            {!!questions.filter(q => !!q.shareCount).length ? t("questionBuilder.releaseAgainButton") : t("questionBuilder.releaseAttendanceButton")}
                        </div>
                    </>
                }


                {isSharingAll &&
                    <>
                        <div className={classes.rowSeparator}/>
                        <YuJaButton
                            tabIndex={0}
                            type={"delete"}
                            onClick={() => setEndPollModalShow(true)}
                            style={{...btnStyle}}
                        >
                            <SQUARE_ICON style={{marginRight: 5}}/>
                            {t("questionBuilder.finishText")}
                        </YuJaButton>
                    </>
                }

                {poll.pollType === POLL_TYPE.ATTENDANCE && isSharing &&
                    <>
                        <div className={classes.rowSeparator}/>
                        <YuJaButton
                            tabIndex={0}
                            type={"delete"}
                            onClick={() => setEndPollModalShow(true)}
                            style={{...btnStyle, width: "fit-content"}}
                        >
                            <SQUARE_ICON style={{marginRight: 5}}/>
                            {t("questionBuilder.finishText")}
                        </YuJaButton>
                    </>
                }

                {/*share each and not ended*/}
                {poll.pollType !== POLL_TYPE.ATTENDANCE && poll.pollShareMode === POLL_SHARE_MODE.SHARE_EACH && !poll.pollEnded &&
                    <>
                        <div className={classes.rowSeparator}/>
                        <YuJaButton
                            tabIndex={0}
                            type={"delete"}
                            onClick={() => setEndPollModalShow(true)}
                            style={{...btnStyle}}
                        >
                            <SQUARE_ICON style={{marginRight: 5}}/>
                            {t("questionBuilder.finishText")}
                        </YuJaButton>
                    </>
                }
            </>
        );


    }


    const handleAddTime = async (AddTimeValues, selectedTime) => {
        try {
            if (selectedTime === "") {
                notifyError(t("poll.selectTimeToAdd"));
            } else if (poll.pollShareMode === POLL_SHARE_MODE.SHARE_ALL) {
                let Time = AddTimeValues[selectedTime];
                const pollDetails = {};
                pollDetails.pollTimeLimit = poll.pollTimeLimit + Time;
                setPollEnd(pollEnd + (Time * 1000));
                setIsAddPollTimeModalLoading(true);
                await editPublishedPollDataFromKey(pollDetails, pollKey, pollCode);
                notifySuccess(shareAllAddTimeToastDisplay[selectedTime]);
                resetPollData();
            } else {

                let isSharing = localState === "SHARED" || localState === "GET_READY";
                let serialNo = isSharing ? sharedQuestionNo : currentQuestionNo;
                const question = pollType === POLL_TYPE.ATTENDANCE ? questions[0] : questions[serialNo - 1];

                let Time = AddTimeValues[selectedTime];
                setQueEnd(queEnd + (Time * 1000));
                setIsAddPollTimeModalLoading(true);
                await updateQuestionDetails(pollKey, pollCode, serialNo, {
                    timeLimit: question.timeLimit + Time,
                    AddTime: true
                });

                if (isSharing) {
                    await updatePollDetails(pollKey, pollCode, {qTimeLimit: question.timeLimit + Time}, true);
                }
                notifySuccess(shareEachAddTimeToastDisplay[selectedTime]);
                resetPollData();
            }
        } finally {
            setIsAddPollTimeModalLoading(false);
        }
        setShowAddTimeModal(false);
    }

    const renderEditBtn = () => {

        const isVisible = (!questions.filter(q => !!q.shareCount).length
            || (poll.pollShareMode === POLL_SHARE_MODE.SHARE_EACH && poll.pollType !== POLL_TYPE.ATTENDANCE)
            || poll.pollShareMode === POLL_SHARE_MODE.UNKNOWN);


        let isSharingAll = (
                poll.pollShareMode === POLL_SHARE_MODE.SCHEDULE
                || poll.pollShareMode === POLL_SHARE_MODE.SHARE_ALL
            )
            && (localState === "GET_READY_ALL" || localState === "SHARED_ALL");

        let isSharing = localState === "GET_READY" || localState === "SHARED";


        return (
            <YuJaTooltip
                disabled={!isSharingAll && !isSharing}
                placement={"bottom"}
                tooltipStyle={{maxWidth: 350}}
                text={poll.pollType === POLL_TYPE.ATTENDANCE
                    ? t("poll.attendanceLockedDuringSharing")
                    : t("poll.pollLockedDuringSharing")
                }
            >
                <Button
                    disabled={(isSharing || isSharingAll)}
                    aria-haspopup={"dialog"}
                    className={`${classes.smallBtn} ${(isSharing || isSharingAll) ? classes.disabled : ""}`}
                    style={{width: 75}}
                    onClick={() => {
                        if (!isSharingAll && !isSharing) {
                            setEditActivityModalShow(true);
                        }
                    }}
                >
                    <PENCIL_ICON style={{marginRight: 7}}/>
                    {t("common.edit")}
                </Button>
            </YuJaTooltip>
        );
    }


    const renderQueControlBar = () => {
        const navigate = (serialNo) => {
            if (serialNo === 0 || serialNo > questions.length) {
                return ;
            }
            setCurrentQuestionNo(serialNo);
        }

        const disableNavigating = isShareQuestionProcessing || localState === "SHARED" || localState === "GET_READY";
        let isUntimed;

        if (disableNavigating && sharedQuestionNo > 0) {
            isUntimed = !pollData.questions[sharedQuestionNo - 1].timeLimit;
        } else {
            isUntimed = !pollData.questions[currentQuestionNo - 1].timeLimit;
        }

        // (pollType === POLL_TYPE.MERGED_POLL && !isShareAll() && sharedQuestionNo > 0 && !pollData.questions[sharedQuestionNo - 1].timeLimit) // untimed share each


        return (
            <div className={`${classes.row} ${classes.releaseQueBar}`}>
                <YuJaTooltip
                    disabled={!disableNavigating}
                    text={t("poll.cannotSwitchQuestionDuringSharing")}
                    tooltipStyle={{maxWidth: 260}}
                >
                    <div className={classes.row} style={{gap: 5}}>
                        <span
                            tabIndex={0}
                            className={`${classes.navigateIcon} ${disableNavigating || currentQuestionNo === 1 ? classes.disabled : ""}`}
                            onClick={() => disableNavigating ? () => {} : navigate(currentQuestionNo - 1)}
                        >
                            <ARROW_LEFT/>
                        </span>

                        <span style={{color: "#2D2D2D"}}>
                            {t("table.questionsHeader")}
                            <input
                                type={"number"}
                                disabled={disableNavigating}
                                className={classes.questionIndexInputBox}
                                value={`${questionIndexInputVal}`}
                                style={{cursor: disableNavigating ? "not-allowed" : "unset"}}
                                onChange={(e) => {
                                    let serialNo = parseInt(e.target.value);
                                    setQuestionIndexInputVal(serialNo);
                                }}

                                onKeyUp={(e) => {
                                    if (e.code === "Enter") {
                                        if (!!questionIndexInputVal) {
                                            if (questionIndexInputVal < 1) {
                                                setQuestionIndexInputVal(1);
                                                setCurrentQuestionNo(1);
                                            } else if (questionIndexInputVal > questions.length) {
                                                setQuestionIndexInputVal(questions.length);
                                                setCurrentQuestionNo(questions.length);
                                            } else {
                                                setCurrentQuestionNo(questionIndexInputVal);
                                            }
                                        } else {
                                            setQuestionIndexInputVal(currentQuestionNo);
                                        }
                                    }

                                }}

                                onBlur={(e) => {
                                    if (!!e.target.value) {
                                        let serialNo = parseInt(e.target.value);
                                        if (serialNo < 1) {
                                            setQuestionIndexInputVal(1);
                                            setCurrentQuestionNo(1);
                                        } else if (serialNo > questions.length) {
                                            setQuestionIndexInputVal(questions.length);
                                            setCurrentQuestionNo(questions.length);
                                        } else {
                                            setCurrentQuestionNo(serialNo);
                                        }
                                    } else {
                                        setQuestionIndexInputVal(currentQuestionNo);
                                    }
                                }}

                            />
                            / {questions.length}
                        </span>

                        <span
                            tabIndex={0}
                            className={`${classes.navigateIcon} ${disableNavigating || currentQuestionNo === questions.length ? classes.disabled : ""}`}
                            onClick={() => disableNavigating ? () => {} :  navigate(currentQuestionNo + 1)}
                        >
                            <ARROW_RIGHT/>
                        </span>
                    </div>
                </YuJaTooltip>


                <Countdown
                    ref={countDownRef}
                    className="pollPanelTimerText"
                    autoStart={true}
                    date={isShareAll() ? pollEnd : queEnd}
                    key={isShareAll() ? pollEnd : queEnd}
                    renderer={renderTimer}
                    onComplete={timeUp}
                />


                <div className={classes.rowSeparator}/>

                <YuJaTooltip
                    disabled={!disableNavigating}
                    text={t("poll.cannotReleaseAnyQuestionDuringSharing")}
                    tooltipStyle={{maxWidth: 260}}
                >
                    <div
                        className={`${classes.releaseQueBtn} ${disableNavigating ? classes.disabled : ""}`}
                        style={{width: "fit-content", minWidth: 120, padding: "0 15px"}}
                        onClick={() => {
                            if (!disableNavigating) {
                                handleShare();
                            }
                        }}
                    >
                        <span className={`${isShareQuestionProcessing ? classes.precessingText : ""}`}>
                            {questions.find(i => i.serialNo === currentQuestionNo)?.shareCount
                                ? t("poll.reReleaseQuestionShort")
                                : t("poll.releaseQuestionShort")
                            }{currentQuestionNo}
                        </span>
                    </div>
                </YuJaTooltip>
            </div>
        );
    }


    if (pageView === RELEASE_ACTIVITY_VIEW.RELEASE_OPTION_VIEW) {
        return (
            <ViewReleaseOptions
                pollData={pollData}
                setPageView={setPageView}
                handleShareAll={handleShareAll}
                handleOpen={handleOpen}
                resetPollData={resetPollData}
            />
        );
    }

    if (pageView === RELEASE_ACTIVITY_VIEW.METRIC_VIEW) {
        return (
            <ViewMetrics
                pollData={pollData}
                participantsOverallData={participantsAllAnalysisData}
                browserAnalysisData={browserAnalysisData}
                participants={participantsData}
                setPageView={setPageView}
            />
        );
    }


    return (
        <div className={classes.parentContainer}>
            <AddPollTimeModal
                show={showAddTimeModal}
                setShow={setShowAddTimeModal}
                handleSubmit={handleAddTime}
                AddTimeOptions={isShareAll() ? shareAllAddTimeOptions : shareEachAddTimeOptions}
                AddTimeValues={isShareAll() ? shareAllAddTimeValues : shareEachAddTimeValues}
                isLoading={isAddPollTimeModalLoading}
            />

            <EndPollModal
                show={endPollModalShow}
                setModalShow={setEndPollModalShow}
                localState={localState}
                poll={poll}
                handleStop={handleStop}
                handleStopAll={handleStopAll}
            />

            <EditActivityModal
                show={editActivityModalShow}
                setShow={setEditActivityModalShow}
                publishedData={pollData}
                reloadPollData={reloadPollData}
            />

            <div className={classes.mainCard} style={{paddingRight: 2, paddingLeft: 2}}>
                <div className={classes.row} style={{...stableScrollBarContainerStyle, color: "#35363A", flexWrap: "wrap", rowGap: 8}}>
                    <div className={classes.row} style={{gap: 7, flex: 1, minWidth: 120, marginRight: 10}}>


                        <OverflowText>
                            <h1 className={classes.pollTitleText}>{pollTitle}</h1>
                        </OverflowText>

                        <ViewActivityInfoIcon pollData={pollData}/>
                    </div>

                    {renderEditBtn()}

                    <div className={classes.rowSeparator}/>
                    {canHavePollCode(poll) &&
                        <>
                            <span style={{marginRight: 5, whiteSpace: "nowrap"}}>{t("questionBuilder.joinCodeText")}: </span>
                            <YuJaTooltip
                                text={!copied
                                    ? (pollType === POLL_TYPE.ATTENDANCE
                                            ? t("questionBuilder.copyAttendanceCodeDesc")
                                            : t("questionBuilder.copyPollCodeDesc")
                                    )
                                    : t("questionBuilder.copiedText")
                                }
                                placement={"bottom"}
                                onOpenChangeCb={(isOpen) => {
                                    if (!isOpen) {
                                        setTimeout(() => {
                                            setCopied(false);
                                        }, 300);
                                    }
                                }}
                            >
                                <Button
                                    aria-label={t("accessibility.copyCodeText")}
                                    style={{display: "inline-block", marginRight: 7}}
                                    onClick={() => clipBoardRef.current.onClick()}
                                >
                                    <CopyToClipboard
                                        ref={clipBoardRef}
                                        text={pollCode}
                                        onCopy={() => setCopied(true)}
                                    >
                                    <span
                                        className={`${classes.pollCodeText} ${classes.row} ${copied ? classes.copied : ""}`}
                                    >
                                        {pollCode}
                                        <COPY_ICON style={{marginLeft: 5, flexShrink: 0}}/>
                                    </span>
                                    </CopyToClipboard>
                                </Button>
                            </YuJaTooltip>
                        </>
                    }

                    <ViewActivityShareButton pollData={pollData}/>



                    {/*timer*/}
                    {renderActionButton()}
                </div>


                {poll.pollShareMode === POLL_SHARE_MODE.SCHEDULE &&
                    <div className={classes.row} style={{...stableScrollBarContainerStyle, padding: 0, margin: "0 2px"}}>
                        <div className={classes.disabledNotification} style={{margin: 0, display: "inline-block"}}>
                            <Megaphone style={{marginRight: 5}}/>
                            <span className={classes.title} style={{marginRight: 3}}>
                                {t("common.attentionPrefix")}
                            </span>
                            {(Date.now() > new Date(poll.endTime) || poll?.pollState === POLL_STATE.STOPPED_SCHEDULED)
                                ?
                                (
                                    <>
                                        {t("questionBuilder.schedulePollExpiredTitleStart")}
                                        <span className={classes.title} style={{margin: "0 5px"}}>
                                            {convertTime(poll.startTime)}
                                        </span>
                                        {t("questionBuilder.schedulePollExpiredTitleMid")}
                                        <span className={classes.title} style={{margin: "0 5px"}}>
                                            {convertTime(poll.endTime)}
                                        </span>
                                        {t("questionBuilder.schedulePollExpiredTitleEnd")}
                                    </>
                                )
                                :
                                (
                                    <>
                                        {Date.now() > new Date(poll.startTime)
                                            ? <>
                                                {t("questionBuilder.schedulePollLiveTitle")}
                                                <span className={classes.title} style={{margin: "0 5px"}}>
                                                    {convertTime(poll.endTime) + "."}
                                                </span>
                                            </>
                                            : <>
                                                {t("questionBuilder.schedulePollFutureTitlePrefix")}
                                                <span className={classes.title} style={{margin: "0 5px"}}>
                                                    {convertTime(poll.startTime) + "."}
                                                </span></>
                                        }
                                        {t("questionBuilder.updateReleaseSchedulePrefix")}
                                        <span
                                            style={{
                                                color: "#0277AD",
                                                textDecoration: "underline",
                                                fontWeight: "600",
                                                cursor: "pointer",
                                                marginLeft: 5
                                            }}
                                            onClick={() => setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_OPTION_VIEW)}
                                        >
                                            {t("questionBuilder.updateReleaseSchedule")}
                                        </span>
                                    </>
                                )
                            }
                        </div>
                    </div>
                }

                {!getRedirectUrl(poll) && poll.syncLmsOption === SYNC_LMS_OPTIONS.LMS_API_SYNC &&
                    <div className={classes.row} style={{...stableScrollBarContainerStyle, padding: 0, margin: "0 2px"}}>
                        <div className={classes.disabledNotification} style={{margin: 0, display: "inline-block"}}>
                            <Megaphone style={{marginRight: 5}}/>
                            {/*<span className={classes.title}>*/}
                            {/*    {t("common.attentionPrefix")}*/}
                            {/*</span>*/}
                            <span className={classes.title} style={{fontWeight: "unset"}}>
                                {t("poll.sharePollButtonDisabledBanner", {
                                    activityType: pollType === POLL_TYPE.ATTENDANCE
                                        ? deCapitalizeWord(t("attendance.label"))
                                        : deCapitalizeWord(t("poll.mergedModeText"))
                                })}
                            </span>
                        </div>
                    </div>
                }

                {poll.pollShareMode === POLL_SHARE_MODE.SHARE_EACH && pollType !== POLL_TYPE.ATTENDANCE &&
                    renderQueControlBar()
                }

                <div className={classes.row} style={{flex: 1, minHeight: 0, width: "100%"}}>
                    {poll.pollType !== POLL_TYPE.ATTENDANCE &&
                        <Accordion.Root
                            className={classes.column}
                            style={{
                                ...stableScrollBarContainerStyle,
                                gap: 15,
                                overflowY: "auto",
                                height: "100%",
                                flex: 1,
                                minWidth: 0,
                                paddingTop: 2,
                            }}
                            value={openedQuestionNo > 0 ? [openedQuestionNo] : []}
                            onValueChange={(val) => {
                                if (!val.length) {
                                    setOpenedQuestionNo(-1);
                                } else {
                                    setOpenedQuestionNo(val[0]);
                                    // setCurrentQuestionNo(val[0]);
                                }
                            }}
                        >
                            {questions.map((question, index) => {

                                return (
                                    <ViewQuestionCard
                                        key={index}
                                        poll={poll}
                                        currentQuestionNo={
                                            poll.pollShareMode === POLL_SHARE_MODE.SHARE_EACH || isActivityEnded()
                                                ? currentQuestionNo
                                                : -1
                                        }/*don't show the blue border when the poll is not in share by question mode*/
                                        localState={localState}
                                        openedQuestionNo={openedQuestionNo}
                                        question={question}
                                        isActivityEnded={isActivityEnded()}
                                        responseCountData={responseCountData}
                                        reactionCountData={reactionCountData}
                                    />
                                );
                            })}
                        </Accordion.Root>
                        // <div
                        //     className={classes.column}
                        //     style={{
                        //         ...stableScrollBarContainerStyle,
                        //         gap: 15,
                        //         overflowY: "auto",
                        //         height: "100%",
                        //         flex: 1,
                        //         minWidth: 0,
                        //         paddingTop: 2,
                        //     }}
                        // >
                        //     {questions.map((question, index) => {
                        //         const disableNavigating =
                        //             (poll.pollShareMode !== POLL_SHARE_MODE.SHARE_EACH && !isActivityEnded())
                        //             || localState === "SHARED"
                        //             || localState === "GET_READY";
                        //         return (
                        //             <ViewQuestionCard
                        //                 key={index}
                        //                 poll={poll}
                        //                 currentQuestionNo={
                        //                     poll.pollShareMode === POLL_SHARE_MODE.SHARE_EACH || isActivityEnded()
                        //                         ? currentQuestionNo
                        //                         : -1
                        //                 }/*don't show the blue border when the poll is not in share by question mode*/
                        //                 setCurrentQuestionNo={setCurrentQuestionNo}
                        //                 localState={localState}
                        //                 openedQuestionNo={openedQuestionNo}
                        //                 setOpenedQuestionNo={setOpenedQuestionNo}
                        //                 question={question}
                        //                 disableNavigating={disableNavigating}
                        //                 isActivityEnded={isActivityEnded()}
                        //                 responseCountData={responseCountData}
                        //                 reactionCountData={reactionCountData}
                        //             />
                        //         );
                        //     })}
                        // </div>
                    }

                    {poll.pollType === POLL_TYPE.ATTENDANCE &&
                        <div
                            className={classes.column}
                            style={{
                                ...stableScrollBarContainerStyle,
                                gap: 15,
                                overflowY: "auto",
                                height: "100%",
                                flex: 1,
                                minWidth: 0
                            }}
                        >
                            <div className={classes.row} style={{alignItems: "start", gap: 20}}>
                                <div className={classes.column} style={{flex: 1, minWidth: 0}}>
                                    <span style={{
                                        fontWeight: "500",
                                        color: "#000",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }}>
                                            <LatexHTMLInline>{questions[0]?.queTitle}</LatexHTMLInline>
                                    </span>
                                    <div style={{height: 20}}/>

                                    <span>
                                        {!!questions[0]?.correctAnswers ? questions[0]?.correctAnswers[0] : ""}
                                    </span>
                                </div>

                                <div className={classes.column}
                                     style={{width: 350, marginRight: 10, alignSelf: "center"}}>
                                    <SAQuestion
                                        questions={questions}
                                        setQuestions={() => {
                                        }}
                                        mapInitialized={mapInitialized}
                                        setMapInitialized={setMapInitialized}
                                        geofence={geofence}
                                        setGeofence={() => {
                                        }}
                                        syncLms={syncLms}
                                        setSyncLms={() => {
                                        }}
                                        selectedQuestion={questions[0]}
                                        pollType={pollType}
                                        mapView={true}
                                        questionBuilder={false}
                                        editable={false}
                                        userSettings={{}}
                                    />
                                </div>
                            </div>
                        </div>
                    }

                    <ViewMetricCards
                        pollData={pollData}
                        liveResponsesData={liveResponsesData}
                        activeStudents={activeStudents}
                        curQuestionNo={currentQuestionNo}
                        isActivityEnded={isActivityEnded()}
                        responseData={responsesAnalysisData}
                        participantData={participantsAnalysisData}
                        participantsOverallData={participantsAllAnalysisData}
                        localState={localState}
                    />
                </div>
            </div>
        </div>
    );
}